import React from 'react'

export const StrategizeHome = () => {
  return (
    <div>StrategizeHome</div>
  )
}

